function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Space, Button, Input, Select, DatePicker, Alert, Tag, Popover, Statistic } from "antd";
import { Col, Row, Container } from "react-bootstrap";
import Common from "./includes/Common";
import moment from 'moment';
import Moment from 'react-moment';
import { ThreeDots, XLg, PersonFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var BusinessProviderCommission = function BusinessProviderCommission() {
  var _useState = useState(moment().startOf('month').format()),
    _useState2 = _slicedToArray(_useState, 2),
    from = _useState2[0],
    setFrom = _useState2[1];
  var _useState3 = useState(moment().endOf('month').format()),
    _useState4 = _slicedToArray(_useState3, 2),
    to = _useState4[0],
    setTo = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    billsCount = _useState6[0],
    setbillsCount = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedBusinessProvider = _useState8[0],
    setSelectedBusinessProvider = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isFormDataLoading = _useState0[0],
    setIsFormDataLoading = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    errorMessage = _useState12[0],
    setErrorMessage = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    billsList = _useState14[0],
    setChecksList = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    businessProviders = _useState16[0],
    setbusinessProviders = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    open = _useState18[0],
    setOpen = _useState18[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var hide = function hide() {
    setOpen(false);
  };
  var handleOpenChange = function handleOpenChange(newOpen) {
    setOpen(newOpen);
  };
  var handleBusinessProviderChange = function handleBusinessProviderChange(v) {
    if (businessProviders.filter(function (p) {
      return p.value == v;
    }).length > 0) setSelectedBusinessProvider(businessProviders.filter(function (p) {
      return p.value == v;
    })[0]);
  };
  var onFinish = function onFinish(values) {
    setIsFormDataLoading(true);
    setFrom(moment(values.from).format());
    setTo(moment(values.to).format());
    setSelectedBusinessProvider(businessProviders.filter(function (p) {
      return p.value == values.business_provider_id;
    })[0]);
    axios.get(Common.baseApiUrl + "getbusinessproviderbills/" + moment(values.from).format() + "/" + moment(values.to).format() + "/" + values.business_provider_id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setbillsCount(response.data.bills.length);
        setOpen(false);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue ' + error.toString());
    })["finally"](function () {
      setIsFormDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getbusinessproviders/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setbusinessProviders([]);
        response.data.providers.forEach(function (p) {
          setbusinessProviders(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.name
            }]);
          });
        });
        if (response.data.providers.length > 0) {
          //form.setFieldsValue({business_provider_id: response.data.providers[0].id});
          //setSelectedBusinessProvider({value: response.data.providers[0].id, label: response.data.providers[0].name})
        }
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue ' + error.toString());
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#EAE0E0",
              minHeight: "300px",
              borderRadius: "4px",
              padding: "10px"
            },
            children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              message: errorMessage,
              type: "error",
              banner: true
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx("h6", {
                style: {
                  color: "#98817F"
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "RISTOURNE AMBULANCIER"
                })
              }), /*#__PURE__*/_jsx(Popover, {
                placement: "topLeft",
                open: open,
                trigger: "click",
                onOpenChange: handleOpenChange,
                title: "RECHERCHE",
                content: /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  onFinish: onFinish,
                  layout: "vertical",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "business_provider_id",
                    rules: [{
                      required: true,
                      message: "Choisir un apporteur"
                    }],
                    children: /*#__PURE__*/_jsx(Select, {
                      options: businessProviders,
                      onChange: handleBusinessProviderChange,
                      placeholder: "Choisir un apporteur"
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "from",
                    rules: [{
                      required: true,
                      message: "Choisir une date de depart"
                    }],
                    children: /*#__PURE__*/_jsx(DatePicker, {
                      showTime: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "to",
                    rules: [{
                      required: true,
                      message: "Choisir une date de d'arrivé"
                    }],
                    children: /*#__PURE__*/_jsx(DatePicker, {
                      showTime: true
                    })
                  }), /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Form.Item, {
                      children: /*#__PURE__*/_jsx(Button, {
                        type: "primary",
                        htmlType: "submit",
                        children: /*#__PURE__*/_jsx("b", {
                          children: "ENVOYER"
                        })
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      children: /*#__PURE__*/_jsx(Button, {
                        type: "link",
                        onClick: function onClick() {
                          setOpen(false);
                        },
                        icon: /*#__PURE__*/_jsx(XLg, {
                          size: 24
                        }),
                        children: " Fermer"
                      })
                    })]
                  })]
                }),
                children: /*#__PURE__*/_jsx(Button, {
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(ThreeDots, {
                      size: 20
                    })
                  })
                })
              }), selectedBusinessProvider && isFormDataLoading == false && billsCount != null && /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(Tag, {
                  color: "#D86A67",
                  children: selectedBusinessProvider.label
                }), /*#__PURE__*/_jsxs(Tag, {
                  color: "#D86A67",
                  children: ["Du ", /*#__PURE__*/_jsx(Moment, {
                    date: from,
                    format: "DD/MM/YYYY"
                  })]
                }), /*#__PURE__*/_jsxs(Tag, {
                  color: "#D86A67",
                  children: ["Au ", /*#__PURE__*/_jsx(Moment, {
                    date: to,
                    format: "DD/MM/YYYY"
                  })]
                })]
              })]
            }), selectedBusinessProvider && isFormDataLoading == false && billsCount != null && /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center",
                padding: "10px"
              },
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PersonFill, {
                size: 45
              }), /*#__PURE__*/_jsx(Statistic, {
                value: billsCount,
                suffix: "Patients transport\xE9(s)"
              })]
            })]
          })
        })
      })
    })
  });
};
export default BusinessProviderCommission;